/* IntelApps — Services Page */
import React, { useEffect } from 'react';
import Header from '../parts/Header.js';
import Footer from '../parts/Footer.js';
import ServicesGrid from '../parts/Service.js';
import DiscussCTA from '../parts/Discuss.js';

export default function ServicesPage() {
  useEffect(() => { document.title = 'IntelApps — Services'; }, []);

  return (
    <>
      <Header />
      <main>
        <section className="page-hero">
          <div className="container page-hero-grid">
            <div>
              <span className="eyebrow">Services</span>
              <h1>Our Services</h1>
              <p className="page-hero-sub">Comprehensive digital solutions tailored to your business needs.</p>
            </div>
          </div>
        </section>
        <ServicesGrid />
        <DiscussCTA />
      </main>
      <Footer />
    </>
  );
}
